import React, {useState} from 'react';
import {useSelector, useDispatch} from "react-redux";

import SearchField from "../../components/SearchField";
import {
    getModuleItems,
    updateArticleQuery,
    updateModuleItemQuery,
    getUnassignedArticles,
    addArticlesToModule,
    removeArticlesFromModule
} from "./reducer";
import ArticleList from "./ArticleList";

const AssignmentPanel = (props) => {
    const [selectedArticleGtins, setSelectedArticleGtins] = useState({});
    const [selectedModuleItemGtins, setSelectedModuleItemGtins] = useState({});

    const {articleQuery, moduleItemQuery} = useSelector(state => state.moduleAdmin.toJS());

    const totalArticleCount = useSelector(state => state.moduleAdmin.get('articlesPagination').get('totalElements'));

    const moduleItems = useSelector(state => getModuleItems(state.moduleAdmin).toJS());
    const articles = useSelector(state => getUnassignedArticles(state.moduleAdmin).toJS());

    const dispatch = useDispatch();

    const moduleArticles = moduleItems.map(item => item.article);

    const addArticles = () => {
        const gtins = Object.keys(selectedArticleGtins);

        setSelectedArticleGtins({});
        setSelectedModuleItemGtins({});

        dispatch(addArticlesToModule(gtins));
    };

    const removeArticles = () => {
        const gtins = Object.keys(selectedModuleItemGtins);

        setSelectedArticleGtins({});
        setSelectedModuleItemGtins({});

        dispatch(removeArticlesFromModule(gtins));
    };

    return (
        <div className="row">
            <div className="col-12">
                <div className="row">
                    <div className="col-lg-5">
                        <h6>Nicht zugeordnete Artikel ({articles.length}/{totalArticleCount})</h6>
                        <hr/>
                    </div>
                    <div className="col-lg-2">
                    </div>
                    <div className="col-lg-5">
                        <h6>Dem Modul zugeordnete Artikel ({moduleItems.length})</h6>
                        <hr/>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-5">
                        <SearchField className="mb-2 mr-sm-2 mb-sm-0" value={articleQuery}
                                     onCommit={(query) => dispatch(updateArticleQuery(query))}/>
                    </div>
                    <div className="col-lg-2">
                    </div>
                    <div className="col-lg-5">
                        <SearchField className="mb-2 mr-sm-2 mb-sm-0"
                                     value={moduleItemQuery}
                                     onCommit={(query) => dispatch(updateModuleItemQuery(query))}/>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-5">
                        <ArticleList articles={articles} selectedGtins={selectedArticleGtins}
                                     setSelection={(gtins) => setSelectedArticleGtins(gtins)}/>
                    </div>
                    <div className="col-lg-2">
                        <div className="row mt-auto">
                            <div className="col-4">
                            </div>
                            <div className="col-4">
                                <button className="btn btn-default mt-3" style={{width: '100%', margin: '10px 0px'}}
                                        type="button" onClick={addArticles}>
                                    <i className="fa fa-angle-right">&nbsp;</i>
                                </button>

                                <button className="btn btn-default mt-5" style={{width: '100%', margin: '10px 0px'}}
                                        type="button" onClick={removeArticles}>
                                    <i className="fa fa-angle-left">&nbsp;</i>
                                </button>
                            </div>
                            <div className="col-4">
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-5">
                        <ArticleList articles={moduleArticles} selectedGtins={selectedModuleItemGtins}
                                     setSelection={(gtins) => setSelectedModuleItemGtins(gtins)}/>
                    </div>
                </div>
            </div>
        </div>
    );

};
export default AssignmentPanel;


// WEBPACK FOOTER //
// ./src/admin/module/admin/AssignmentPanel.js